package diana.soleil.design.iraniancanadienbazzar.locale

import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import diana.soleil.design.iraniancanadienbazzar.core.model.AppearanceMode
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import org.koin.dsl.module

/**
 * Holds the app's light/dark preference as observable state, **persisted** via [AppPreferences] so it
 * survives restarts. Mirrors [LocaleController]'s shape so the composition root treats appearance and
 * language the same way.
 *
 * Defaults to [AppearanceMode.System]: `App()` resolves it against `isSystemInDarkTheme()` and hands
 * the boolean to `AppTheme`. Kept device-local (no `users/{uid}` mirror) — see
 * `AppPreferences.appearanceCode`.
 */
class AppearanceController(private val preferences: AppPreferences) {
    private val _mode = MutableStateFlow(AppearanceMode.fromCode(preferences.appearanceCode))
    val mode: StateFlow<AppearanceMode> = _mode.asStateFlow()

    fun setMode(mode: AppearanceMode) {
        preferences.appearanceCode = mode.code
        _mode.value = mode
    }
}

val appearanceModule = module {
    single { AppearanceController(get()) }
}
